var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnitlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 32,
    viewBox: "0 0 135 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-b3520fe3": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42273 10.4852C2.42273 8.30068 3.28608 6.24348 4.85617 4.69158C6.42489 3.1403 8.50461 2.28577 10.7114 2.28577H29.8513V6.45249H10.7114C9.62964 6.45249 8.60764 6.87358 7.83358 7.6376C7.06089 8.40354 6.63369 9.41524 6.63369 10.4852L6.60965 17.4791C6.41459 19.3367 4.99903 20.8349 3.16794 21.1113L2.42273 21.2244V10.4852Z",
    fill: "#E6000E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42273 29.7144V25.5473H21.5626C22.6444 25.5473 23.6664 25.1263 24.4377 24.3604C25.2138 23.5972 25.639 22.5864 25.639 21.5147L25.6424 14.877C25.6424 12.9002 27.1315 11.1859 29.1068 10.8877L29.8513 10.7758V21.5147C29.8513 23.6993 28.988 25.7558 27.4172 27.3076C25.8491 28.86 23.7715 29.7144 21.5626 29.7144H2.42273Z",
    fill: "#E6000E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6637 21.2246V15.9152L16.1361 18.8205L13.6079 15.9152V21.2246H10.2589V10.7758H13.4314L16.1361 14.1351L18.8402 10.7758H22.014V21.2246H18.6637Z",
    fill: "#E6000E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.609 18.2251H64.0033L65.8064 13.5192L67.609 18.2251ZM68.822 21.3961L69.6263 23.4989H73.5922L67.6283 8.5H64.0423L58.0771 23.4989H61.9817L62.7878 21.3961H68.822ZM51.7557 23.4997V14.5856L47.8842 19.294L44.0144 14.5856V23.4997H40.137V8.50072H43.9613L47.8842 13.6581L51.8083 8.50072H55.6326V23.4997H51.7557ZM76.0584 8.50103V23.4999H79.9371V11.9843H85.3594V8.50103H76.0584ZM97.7352 17.6239V23.4999H101.613V8.50103H97.7352V14.0986H91.9754V8.50103H88.098V23.4999H91.9754V17.6239H97.7352ZM125.994 23.4999V11.9843H121.463V8.50103H134.423V11.9843H129.872V23.4999H125.994ZM114.858 14.9517V23.4999H118.738V8.50103H115.389L109.322 16.9592V8.50103H105.442V23.4999H108.686L114.858 14.9517Z",
    fill: "#E6000E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnitlogo);
export default __webpack_public_path__ + "static/media/magnitlogo.c8f0875bd8b7245d3e9384274d173d0c.svg";
export { ForwardRef as ReactComponent };